/* Ventana del cupon. Aparece una vez cada 14 dias. Nunca encima del carrito
   ni del pago, y nunca si la persona ya dejo su correo. */
(function () {
  var pop = document.getElementById('pop-cupon');
  if (!pop) return;

  var LLAVE = 'tlr-pop-cupon';
  var DIAS = 14;
  var ruta = document.body.className || '';
  if (ruta.indexOf('plantilla-cart') !== -1) return;

  function visto() {
    try {
      var v = localStorage.getItem(LLAVE);
      if (!v) return false;
      if (v === 'ya') return true;
      return (Date.now() - parseInt(v, 10)) < DIAS * 864e5;
    } catch (e) { return true; }
  }
  function marcar(valor) {
    try { localStorage.setItem(LLAVE, valor || String(Date.now())); } catch (e) {}
  }

  var abierto = false;
  function abrir() {
    if (abierto || visto()) return;
    abierto = true;
    marcar();
    if (typeof pop.showModal === 'function') { pop.showModal(); } else { pop.setAttribute('open', ''); }
  }
  function cerrar() {
    if (typeof pop.close === 'function') { pop.close(); } else { pop.removeAttribute('open'); }
  }

  if (visto()) return;

  var reloj = setTimeout(abrir, 12000);
  document.addEventListener('mouseout', function (ev) {
    if (!ev.relatedTarget && ev.clientY <= 0) { clearTimeout(reloj); abrir(); }
  });

  pop.addEventListener('click', function (ev) {
    if (ev.target.closest('[data-pop-x]')) { cerrar(); return; }
    if (ev.target === pop) cerrar();

    var copiar = ev.target.closest('[data-pop-copy]');
    if (copiar && navigator.clipboard) {
      navigator.clipboard.writeText(copiar.getAttribute('data-code'));
      copiar.textContent = 'Codigo copiado';
    }
  });

  /* Shopify recarga la pagina con ?customer_posted=true cuando el correo
     entro bien. Ahi mostramos el codigo y no la volvemos a sacar. */
  var form = pop.querySelector('form');
  if (form) {
    form.addEventListener('submit', function () { marcar('ya'); });
  }
  if (location.search.indexOf('customer_posted=true') !== -1) {
    marcar('ya');
    pop.querySelector('[data-pop-paso="1"]').hidden = true;
    pop.querySelector('[data-pop-paso="2"]').hidden = false;
    abierto = false;
    clearTimeout(reloj);
    if (typeof pop.showModal === 'function') { pop.showModal(); } else { pop.setAttribute('open', ''); }
  }
})();
